import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import App from "./App";
const container = document.getElementById("root");
if (!container) {
    throw new Error("Root container not found");
}
const config = {
    apiBaseUrl: container.dataset.apiBaseUrl,
    authToken: container.dataset.authToken,
    basePath: container.dataset.basePath || "/",
    logoutUrl: container.dataset.logoutUrl || undefined,
};
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(_jsx(App, { ...config }));
